document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');
    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');

    // Update button text based on checked boxes
    function updateButtonText() {
      const checked = dropdown.querySelectorAll('input[type="checkbox"]:checked');
      if (toggle) {
        const labelText = dropdown ? dropdown.getAttribute('data-label') || 'None selected' : 'None selected';
        if (checked.length === 0) {
          // Use data-label from the first checkbox if available
          
          toggle.textContent = labelText;
        } else if (checked.length === 1) {
          toggle.textContent = `${labelText} - 1`;
        } else {
          toggle.textContent = `${labelText} - ${checked.length}`;
        }
      }
    }

    // Initial update
    updateButtonText();

    // Listen for changes
    checkboxes.forEach(cb => cb.addEventListener('change', updateButtonText));
  });

  console.log('igto-multi-select-query.js loaded');
  const selects = document.querySelectorAll('.wp-block-igto-igto-form-multi-select .dropdown[data-taxonomy]');
  console.log(`Found ${selects.length} multi-select dropdowns`);
  const params = new URLSearchParams(window.location.search);

  selects.forEach(select => {
    const taxonomy = select.getAttribute('data-taxonomy');
    if (taxonomy) {
      const paramKey = `${taxonomy}[]`;
      const selectedValues = params.getAll(paramKey);
      console.log(`Checking for taxonomy: ${taxonomy}`);
      console.log(`Current URL params: ${params.toString()}`);
      console.log(`param has ${paramKey}: ${params.has(paramKey)}`);
      console.log(`Selected values for ${paramKey}:`, selectedValues);

      // Check the checkboxes whose value is in selectedValues
      select.querySelectorAll('input[type="checkbox"]').forEach(input => {
        if (selectedValues.includes(input.value)) {
          input.checked = true;
        }
      });

      // Optionally, update the button text after checking
      const toggle = select.querySelector('.dropdown-toggle');
      if (toggle) {
        const checked = select.querySelectorAll('input[type="checkbox"]:checked');
         const labelText = select ? select.getAttribute('data-label') || 'None selected' : 'None selected';
        if (checked.length === 0) {
         
          toggle.textContent = labelText;
        } else if (checked.length === 1) {
          toggle.textContent = `${labelText} - 1`;
        } else {
          toggle.textContent = `${labelText} - ${checked.length}`;
        }
      }
    }
  });
});
